import { BadgeType } from "@/app/@types";
import { supabase } from "../supabase-client";

export const updateMintedBadge = async (
  badgeId: string,
  txHash: string
): Promise<BadgeType | null> => {
  try {
    const { data, error } = await supabase
      .from("badges")
      .update({
        minted: true,
        minted_at: new Date().toISOString(),
        tx_hash: txHash,
      })
      .eq("badge_id", badgeId)
      .select()

    if (error) {
      console.error("Error updating minted badge:", error);
      return null;
    }

    console.log(`Badge ${badgeId} marked as minted`);
    return data;
  } catch (error) {
    console.error("Unexpected error updating minted badge:", error);
    return null;
  }
};
